export default {
      id: "facebook-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#facebook",
      toString: function () {
        return this.url;
      }
    }